const orderByObjectNumber =
  (prop: string, desc = false) =>
  (a: { [key: string]: number }, b: { [key: string]: number }): 1 | -1 | 0 => {
    const propA = a[prop] ? a[prop] : 0
    const propB = b[prop] ? b[prop] : 0

    if (!desc) {
      if (propA < propB) {
        return -1
      }
      if (propA > propB) {
        return 1
      }
    } else {
      if (propB < propA) {
        return -1
      }
      if (propB > propA) {
        return 1
      }
    }

    return 0
  }

export { orderByObjectNumber }
